module.exports = __webpack_public_path__ + "img/6.beb7fd99.png";